import { render, staticRenderFns } from "./WidgetOrderProcess.vue?vue&type=template&id=1be747cf&scoped=true"
import script from "./WidgetOrderProcess.vue?vue&type=script&lang=js"
export * from "./WidgetOrderProcess.vue?vue&type=script&lang=js"
import style0 from "./WidgetOrderProcess.vue?vue&type=style&index=0&id=1be747cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be747cf",
  null
  
)

export default component.exports